<template><div><h1>什么是虚拟组件(virtual component)</h1>
<h2>概念</h2>
<p><code>虚拟组件</code> 是 <code>VUX</code> 组件特有的概念。它指的是一个组件不需要 <code>import</code> 就能使用，组件的代码会在编译时被 <code>vux-loader</code> 替换成真实的 <code>html</code> 代码，比如 <code>x-icon</code> 组件。</p>
<h2>为什么这样实现</h2>
<p>它可以解决按需引入的问题，比如不需要把所有 <code>svg</code> 引入组件而是在编译时根据属性读取相应的 <code>svg</code> 图标直接内联。</p>
<p>它可以解决特殊属性的赋值问题，或者自定义一些特殊写法。</p>
</div></template><script>
export default {
  head: {"title":"什么是虚拟组件(virtual component) | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// what-is-vux-virtual-component-24.vue?345bc191